import React, { memo, useCallback, useEffect, useMemo } from "react";

import { FirmwareDTO, FirmwareType } from "@generated/v2";
import Button from "app/components/Button/Button";
import useDeleteData from "app/hooks/useDeleteData";
import { readerversionDelete } from "app/api/v2/readerFirmwareApi";
import { message, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import { PermissionEnum } from "app/constants/permissionConst";
import Permission from "app/components/Permission/Permission";

interface IProps {
  id: FirmwareDTO["id"];
  type: FirmwareType;
  reload: () => void;
}

const ReaderVersionDeleteButton = ({ id, type, reload }: IProps) => {
  const { t } = useTranslation();

  const { loading, isError, isSuccess, deleteData } = useDeleteData(
    readerversionDelete,
    { type }
  );

  const deleteFirmware = useCallback(() => {
    deleteData(id);
  }, [id, deleteData]);

  useEffect(() => {
    isSuccess && reload();
  }, [isSuccess, reload]);

  useEffect(() => {
    isError && message.error(t("readerFirmware.firmwareDeleteError"));
  }, [isError, t]);

  const deletePermissions: PermissionEnum[] = useMemo(
    () => [PermissionEnum.DESKTOP_VERSION_WRITE],
    []
  );

  return (
    <Permission requiredPermissions={deletePermissions}>
      <Popconfirm
        title={t("readerFirmware.firmwareDeleteConfirm")}
        okText={t("readerFirmware.firmwareDeleteOk")}
        cancelText={t("readerFirmware.firmwareDeleteCancel")}
        placement="left"
        onConfirm={deleteFirmware}
      >
        <Button type="link" loading={loading} icon="delete" />
      </Popconfirm>
    </Permission>
  );
};

export default memo(ReaderVersionDeleteButton);
